import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import { MdMenu } from "react-icons/md";
import { useDispatch } from "react-redux";
import { toggleSidebar } from "../../features/Toggle/sidebarSlice";
import { getuser } from "../CommonDateFormat";

const Navbar = () => {
  const user = getuser();

  const dispatch = useDispatch();
  const handleToggleSidebar = () => {
    dispatch(toggleSidebar());
  };

  return (
    <div className="sticky top-0 z-10">
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static">
          <Toolbar className="bg-orange-600 text-white ">
            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 1 }}
              className="flex items-center gap-x-2"
            >
              <button onClick={handleToggleSidebar} className="lg:hidden">
                <MdMenu size={25} />
              </button>
              <Link to="/dashboard">Home</Link>
            </Typography>

            <Button color="inherit">{user && user?.name } ({user?.role}) </Button>
          </Toolbar>
        </AppBar>
      </Box>
    </div>
  );
};

export default Navbar;
